import { useTranslations } from "@cirrus/core/i18n/provider"

import { LoginWithPasswordFormFieldValues } from "./types"
import { useFrontendConfig } from "../../../FrontendConfig"
import {
  AuthCirrusPlatformCredentials, useLoginFetcher, useLoginService
} from "../../providers/LoginService"
import { useNavigationService } from "../../providers/NavigationService"


export const useLoginWithPassword = () => {
  const { persistLoginPreferences, storeCredentials, getAuthTokens } = useLoginService()
  const { redirectToApp, navigate } = useNavigationService()
  const { login, ...fetcher } = useLoginFetcher()
  const { Customer } = useFrontendConfig()
  const { language } = useTranslations()

  const handleLogin = async ({ password, username }: LoginWithPasswordFormFieldValues) => {
    try {
      const credentials: AuthCirrusPlatformCredentials = {
        grant_type: "password",
        password,
        username: `${Customer}:${username}`,
        browser_token: getAuthTokens().browserToken
      }

      const { data } = await login(credentials)

      persistLoginPreferences({ language })

      if (!data.require_twoFa) return redirectToApp(data)

      storeCredentials(credentials)
      navigate("/2fa")
    } catch (error) {
      console.error(error)
    }
  }

  return { handleLogin, ...fetcher }
}
